import { TranslationSet } from './en';

// TODO: translate values from English
export const fr: TranslationSet = {
  '(From Now)': '(À partir de maintenant)',
  '(From Scheduled)': '(Depuis programmé)',
  '{amount} Off. Expires: {expires}.': '{amount} Désactivé. Expire : {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'Un rapport détaillé montrant chaque activité et combien de temps un technicien ou un membre du personnel a pris entre et sur chaque site avec un temps total sur le site.',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'Un type de service avec l\'inspection activée apparaîtra dans la liste « à inspecter » sur mobile. Il est également utilisé dans les rapports.',
  'Accept Invite': 'Accepter l\'invitation',
  'Add Condition': 'Ajouter une condition',
  'Add deficiencies to the equipment type': 'Ajouter des lacunes au type d\'équipement',
  'Add Deficiency': 'Ajouter une carence',
  'Add Equipment Field': 'Ajouter un champ d\'équipement',
  'Add Equipment Type': 'Ajouter un type d\'équipement',
  'Add Equipment': 'Ajouter de l\'équipement',
  'Add Floor Plan': 'Ajouter un plan d\'étage',
  'Add history by clicking the plus in the top right or by performing a service.': 'Ajoutez de l\'historique en cliquant sur le plus en haut à droite ou en effectuant une prestation.',
  'Add History': 'Ajouter un historique',
  'Add Model Field': 'Ajouter un champ de modèle',
  'Add Model': 'Ajouter un modèle',
  'Add Option': 'Ajouter une option',
  'Add Question': 'Ajouter une question',
  'Add questions using the plus icon in the top right': 'Ajoutez des questions en utilisant l\'icône plus en haut à droite',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'Ajoutez des catégories de mois de service dans Paramètres > Catégories de mois de service. Les mois de service vous permettent de conserver différents types d\'équipements pendant des mois sélectionnés pour chaque emplacement. Exemple : Alarmes en mai et octobre et extincteurs en décembre.',
  'Add Service Month Category': 'Ajouter une catégorie de mois de service',
  'Add Service Type': 'Ajouter un type de service',
  'Add service types in the settings': 'Ajouter des types de services dans les paramètres',
  'Add service types using the plus icon in the top right': 'Ajoutez des types de services à l\'aide de l\'icône plus en haut à droite',
  'Add services to the equipment type': 'Ajouter des services au type d\'équipement',
  'Add site Field': 'Ajouter un champ de site',
  'Add Site Override': 'Ajouter un remplacement de site',
  'Add Site Type': 'Ajouter un type de site',
  'Add Site': 'Ajouter un site',
  'Add Sites': 'Ajouter des sites',
  'Add User': 'Ajouter un utilisateur',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'Ajoutez vos propres champs dans Paramètres > Champs personnalisés > Champs du site',
  'Add': 'Ajouter',
  'Adding': 'Ajout',
  'Address': 'Adresse',
  'Advance from Now': 'Avancez à partir de maintenant',
  'Advance from Scheduled': 'Avancer par rapport à la planification',
  'Agree': 'D\'accord',
  'All Sites Scheduled!': 'Tous les sites programmés !',
  'All': 'Tout',
  'Already have an account? Login': 'Vous avez déjà un compte ? Connexion',
  'An error happened while syncing': 'Une erreur s\'est produite lors de la synchronisation',
  'April': 'avril',
  'August': 'août',
  'Back': 'Retour',
  'Billing Portal': 'Portail de facturation',
  'Building Reports': 'Rapports de construction',
  'Cancel Plan': 'Annuler le forfait',
  'Cancel Subscription': 'Annuler l\'abonnement',
  'Cancel': 'Annuler',
  'Change Model Fields': 'Modifier les champs du modèle',
  'Change Password': 'Changer le mot de passe',
  'Checklist Information': 'Informations sur la liste de contrôle',
  'Checklist Question': 'Question de la liste de contrôle',
  'Checklist': 'Liste de contrôle',
  'Choose File': 'Choisir un fichier',
  'City': 'Ville',
  'Clear All Data': 'Effacer toutes les données',
  'Clear': 'Effacer',
  'Click or tap to add location': 'Cliquez ou appuyez pour ajouter un emplacement',
  'Close': 'Fermer',
  'Company-Wide Reports': 'Rapports à l\'échelle de l\'entreprise',
  'Conditions': 'Conditions',
  'Contact': 'Contacter',
  'Copy Barcode': 'Copier le code-barres',
  'Could not access': 'Impossible d\'accéder',
  'Could not find equipment with the scanned barcode': 'Impossible de trouver l\'équipement avec le code-barres scanné',
  'Could Not Service': 'Impossible de réparer',
  'Create': 'Créer',
  'Creating Your Account': 'Création de votre compte',
  'Credentials are not valid': 'Les informations d\'identification ne sont pas valides',
  'CSV': 'CSV',
  'Custom Equipment Fields': 'Champs d\'équipement personnalisés',
  'Custom Fields': 'Champs personnalisés',
  'Custom Model Fields': 'Champs de modèle personnalisés',
  'Custom site Fields': 'Champs du site personnalisé',
  'Date': 'Date',
  'Debug': 'Débogage',
  'December': 'décembre',
  'Deficiencies': 'Lacunes',
  'Deficiency Report': 'Rapport de carence',
  'Deficiency': 'Carence',
  'Delete Equipment Field?': 'Supprimer le champ d\'équipement ?',
  'Delete Equipment Type?': 'Supprimer le type d\'équipement ?',
  'Delete Equipment Type': 'Supprimer le type d\'équipement',
  'Delete Equipment?': 'Supprimer l\'équipement ?',
  'Delete Equipment': 'Supprimer l\'équipement',
  'Delete Floor Plan?': 'Supprimer le plan d\'étage ?',
  'Delete Model Field?': 'Supprimer le champ modèle ?',
  'Delete Model?': 'Supprimer le modèle ?',
  'Delete Model': 'Supprimer le modèle',
  'Delete Override': 'Supprimer le remplacement',
  'Delete Question?': 'Supprimer la question ?',
  'Delete Question': 'Supprimer la question',
  'Delete Record?': 'Supprimer l\'enregistrement ?',
  'Delete Service Month?': 'Supprimer le mois de service ?',
  'Delete Service Type?': 'Supprimer le type de service ?',
  'Delete Site Field?': 'Supprimer le champ du site ?',
  'Delete Site Type?': 'Supprimer le type de site ?',
  'Delete Site?': 'Supprimer le site ?',
  'Delete Site': 'Supprimer le site',
  'Delete User?': 'Supprimer l\'utilisateur ?',
  'Delete User': 'Supprimer un utilisateur',
  'Delete': 'Supprimer',
  'Deleted Equipment Field': 'Champ d\'équipement supprimé',
  'Deleted Equipment': 'Équipement supprimé',
  'Deleted Floor Plan': 'Plan d\'étage supprimé',
  'Deleted Model Field': 'Champ de modèle supprimé',
  'Deleted Record': 'Enregistrement supprimé',
  'Deleted Service Month': 'Mois de service supprimé',
  'Deleted Service Type': 'Type de service supprimé',
  'Deleted Site Field': 'Champ de site supprimé',
  'Deleted Site Type': 'Type de site supprimé',
  'Detailed': 'Détaillé',
  'Did not want done': 'Je ne voulais pas que ce soit fait',
  'Done by others': 'Fait par d\'autres',
  'Don\'t have an account? Sign Up': 'Vous n\'avez pas de compte ? S\'inscrire',
  'Done': 'Terminé',
  'Edit Dates': 'Modifier les dates',
  'Edit Equipment': 'Modifier l\'équipement',
  'Edit': 'Modifier',
  'Email is not valid': 'L\'e-mail n\'est pas valide',
  'End Date': 'Date de fin',
  'Enter your email address': 'Entrez votre adresse e-mail',
  'Equipment already has this barcode': 'L\'équipement possède déjà ce code-barres',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'L’équipement peut aller d’un extincteur à un tapis roulant. Configurer les types d\'équipement dans Paramètres > Types d\'équipement.s',
  'Equipment Deleted': 'Équipement supprimé',
  'Equipment Due Consolidated Report': 'Rapport consolidé sur l\'équipement dû',
  'Equipment Due Report': 'Rapport d\'échéance d\'équipement',
  'Equipment Field Information': 'Informations sur le terrain de l\'équipement',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'Les champs Équipement vous permettent d\'ajouter différents champs supplémentaires sur le type d\'équipement, tels que « Tension » ou « Km ».',
  'Equipment Fields': 'Domaines d\'équipement',
  'Equipment for a site with all scheduled services.': 'Équipement pour un site avec tous les services programmés.',
  'Equipment Options': 'Options d\'équipement',
  'Equipment Report': 'Rapport d\'équipement',
  'Equipment Service Report': 'Rapport de service de l\'équipement',
  'Equipment SKU': 'UGS d\'équipement',
  'Equipment Type Deleted': 'Type d\'équipement supprimé',
  'Equipment Type': 'Type d\'équipement',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'Les types d\'équipement ajoutent rapidement des définitions d\'inspection et de service à l\'équipement lorsqu\'un modèle le contenant est sélectionné. Exemples : extincteur, tapis roulant, camion',
  'Equipment Types': 'Types d\'équipement',
  'Equipment': 'Équipement',
  'Export Billing Data': 'Exporter les données de facturation',
  'Export Data': 'Exporter des données',
  'Export': 'Exporter',
  'Failed to load organization.': 'Échec du chargement de l\'organisation.',
  'Failed to save the organization.': 'Échec de la sauvegarde de l\'organisation.',
  'February': 'Février',
  'Fill out the options below to prepare your report.': 'Remplissez les options ci-dessous pour préparer votre rapport.',
  'Filter By': 'Filtrer par',
  'FlameTask Basic Subscription': 'Abonnement de base à FlameTask',
  'FlameTask Enterprise Subscription': 'Abonnement FlameTask Entreprise',
  'FlameTask Pro Subscription': 'Abonnement FlameTask Pro',
  'Floor Plan Location': 'Emplacement du plan d\'étage',
  'Floor Plan': 'Plan d\'étage',
  'Floor Plans': 'Plans d\'étage',
  'Force Error': 'Erreur de force',
  'Forgot Password': 'Mot de passe oublié',
  'Generate': 'Générer',
  'Hide "added" history records': 'Masquer les enregistrements d\'historique "ajoutés"',
  'Hide Advanced': 'Masquer Avancé',
  'History': 'Histoire',
  'How long a user spent at a site with time between actions.': 'Combien de temps un utilisateur a passé sur un site avec le temps entre les actions.',
  'If this email matched an account, a link was sent to reset your password.': 'Si cet e-mail correspond à un compte, un lien a été envoyé pour réinitialiser votre mot de passe.',
  'Import Data': 'Importer des données',
  'Import': 'Importer',
  'Inspection Due': 'Inspection due',
  'Inspection Report': 'Rapport d\'inspection',
  'Inspection': 'Contrôle',
  'Inspections are up to date': 'Les inspections sont à jour',
  'January': 'janvier',
  'July': 'juillet',
  'June': 'juin',
  'Leave': 'Partir',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'Liste de tous les équipements du site avec options d\'affichage des services et filtrage en fonction du service et/ou de l\'inspection requis.',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'Liste de tous les sites avec leurs informations. Options permettant de filtrer par statut et par mois de service pour trouver quels sites sont desservis au cours d\'un mois spécifique.',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'Liste des équipements et des défauts du site, filtrée par équipements présentant des défauts qui ont une date d\'ouverture et aucune date de clôture.',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'Liste des équipements sur une plage de dates avec réponses aux questions posées lors de la réalisation d\'une prestation ou d\'une inspection.',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'Liste des équipements d\'un site avec des informations importantes telles que la date de la dernière inspection et le prochain entretien dû, mettant en évidence les équipements à inspecter en rouge.',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'Liste des équipements répondant aux critères de recherche du modèle. Exemple : une liste de 5 pièces d\'équipement dont les informations sur le modèle correspondent à 6LB ABC DRY.',
  'Loading Equipment': 'Équipement de chargement',
  'Loading Models...': 'Chargement des modèles...',
  'Loading Scheduled Services...': 'Chargement des services planifiés...',
  'Loading Scheduled Sites': 'Chargement des sites planifiés',
  'Loading Service Types...': 'Chargement des types de services...',
  'Loading Sites': 'Sites de chargement',
  'Loading Unscheduled Services...': 'Chargement des services non planifiés...',
  'Loading...': 'Chargement...',
  'Location': 'Emplacement',
  'Logging in...': 'Connexion...',
  'Login Failed': 'Échec de la connexion',
  'Login': 'Connexion',
  'Logout': 'Déconnexion',
  'March': 'Mars',
  'May': 'mai',
  'Meter Based Condition': 'État basé sur le compteur',
  'Model Deleted': 'Modèle supprimé',
  'Model Field Information': 'Informations sur le champ du modèle',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'Les champs de modèle vous permettent de décrire et de créer des rapports sur des équipements tels que « Taille », « Type » et « Catégorie ».',
  'Model Fields': 'Champs du modèle',
  'Model Information': 'Informations sur le modèle',
  'Model Name': 'Nom du modèle',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'Les modèles permettent d\'ajouter rapidement des informations sur l\'équipement, telles que le type d\'équipement/les services qui lui appartiennent.',
  'Models': 'Modèles',
  'Months of History (to start of month)': 'Mois d\'histoire (jusqu\'au début du mois)',
  'More Details': 'Plus de détails',
  'Name': 'Nom',
  'Nevermind': 'Peu importe',
  'No Custom Equipment Fields': 'Aucun champ d\'équipement personnalisé',
  'No Deficiencies': 'Aucune lacune',
  'No Equipment Fields': 'Aucun champ d\'équipement',
  'No Equipment Types': 'Aucun type d\'équipement',
  'No Equipment': 'Aucun équipement',
  'No Floor Plans': 'Aucun plan d\'étage',
  'No History': 'Pas d\'historique',
  'No Model Fields': 'Aucun champ de modèle',
  'No Models': 'Aucun modèle',
  'No Open Deficiencies': 'Aucune lacune ouverte',
  'No Open or Closed Issues': 'Aucun problème ouvert ou fermé',
  'No overrides for this Site': 'Aucun remplacement pour ce site',
  'No Questions': 'Aucune question',
  'No Scheduled Services': 'Aucun service programmé',
  'No Scheduled Sites': 'Aucun site programmé',
  'No Service Month Categories': 'Catégories de mois sans service',
  'No Service Types': 'Aucun type de service',
  'No Site Fields': 'Aucun champ de site',
  'No Site Types': 'Aucun type de site',
  'No Sites': 'Aucun site',
  'No Unscheduled Services': 'Aucun service non planifié',
  'No, Go Back': 'Non, reviens',
  'No': 'Non',
  'Not in at the time of inspection': 'Pas présent au moment de l\'inspection',
  'Nothing to Inspect': 'Rien à inspecter',
  'Nothing to Service': 'Rien à entretenir',
  'November': 'novembre',
  'October': 'octobre',
  'Ok': 'D\'accord',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'Ouvrez une déficience en cliquant sur le plus en haut à droite du volet. Une fois le problème résolu, cliquez dessus et définissez la date de clôture.',
  'Open a deficiency by tapping Options > Add Deficiency': 'Ouvrez une déficience en appuyant sur Options > Ajouter une déficience',
  'Open Deficiencies': 'Lacunes ouvertes',
  'Open Deficiency': 'Carence ouverte',
  'Open in Apple Maps': 'Ouvrir dans Apple Maps',
  'Open in Google Maps': 'Ouvrir dans Google Maps',
  'Open Settings': 'Ouvrir les paramètres',
  'Open': 'Ouvert',
  'Optional: Add a deficiency if this option is selected.': 'Facultatif : Ajoutez une lacune si cette option est sélectionnée.',
  'Optional: This can be useful to set meter values easily': 'Facultatif : Cela peut être utile pour définir facilement les valeurs du compteur.',
  'Organization': 'Organisation',
  'Outstanding Equipment': 'Équipement exceptionnel',
  'PDF': 'PDF',
  'Perform From Now': 'Effectuer à partir de maintenant',
  'Perform From Scheduled': 'Effectuer à partir du planning',
  'Perform Service From Scheduled': 'Effectuer le service à partir de la planification',
  'Perform Service': 'Effectuer le service',
  'Perform': 'Effectuer',
  'Phone Number': 'Numéro de téléphone',
  'Please fill out all fields': 'Veuillez remplir tous les champs',
  'Please give a reason': 'Veuillez donner une raison',
  'Please select country first': 'Veuillez d\'abord sélectionner le pays',
  'Popup Note': 'Remarque contextuelle',
  'Preferences': 'Préférences',
  'Preview Details': 'Détails de l\'aperçu',
  'Profile': 'Profil',
  'Purchase Barcodes': 'Acheter des codes-barres',
  'Question Deleted': 'Question supprimée',
  'Question Information': 'Informations sur les questions',
  'Questionnaire Report': 'Rapport du questionnaire',
  'Questions': 'Questions',
  'Range End': 'Fin de plage',
  'Range Start': 'Début de plage',
  'Reactivate': 'Réactiver',
  'Remove': 'Supprimer',
  'Replace Barcode': 'Remplacer le code-barres',
  'Replace Equipment': 'Remplacer l\'équipement',
  'Replaced equipment': 'Équipement remplacé',
  'Report Date': 'Date du rapport',
  'Reports': 'Rapports',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'Gagnez du temps et minimisez les risques en traçant l\'emplacement des équipements sur un plan d\'étage de ce site',
  'Save': 'Enregistrer',
  'Saving': 'Économiser',
  'Scan barcode to make changes': 'Scannez le code-barres pour apporter des modifications',
  'Scan Barcode': 'Scanner le code-barres',
  'Scan': 'Numériser',
  'Schedule': 'Calendrier',
  'Scheduled Event': 'Événement programmé',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'Les définitions de services planifiés peuvent être ajoutées au type d\'équipement dans Paramètres > Types d\'équipement',
  'Scheduled': 'Programmé',
  'See More': 'Voir plus',
  'Selecting an option will add a history record and remove it from the todo list': 'La sélection d\'une option ajoutera un enregistrement d\'historique et le supprimera de la liste de tâches',
  'Selective Equipment Report': 'Rapport sur les équipements sélectifs',
  'September': 'septembre',
  'Service Due': 'Service dû',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'Les catégories de mois de service vous permettent de conserver différents types d\'équipements au cours de différents mois. Par exemple, vous pourriez inspecter les extincteurs en août et mai et les alarmes en octobre.',
  'Service Month Categories': 'Catégories de mois de service',
  'Service Month Category': 'Catégorie du mois de service',
  'Service Month': 'Mois de service',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'Les mois de service vous permettent de conserver différents types d\'équipements pendant des mois sélectionnés pour chaque site. Exemple : Alarmes en mai et octobre et extincteurs en décembre.',
  'Service Months': 'Mois de service',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'Les remplacements de service vous permettent de désactiver un service ou de modifier la fréquence d\'un site spécifique',
  'Service Type Settings': 'Paramètres des types de services',
  'Service Type': 'Type de service',
  'Service Types': 'Types de services',
  'Service': 'Service',
  'Services are up to date': 'Les services sont à jour',
  'Services': 'Prestations',
  'Set answer to equipment field': 'Définir la réponse dans le champ Équipement',
  'Settings': 'Paramètres',
  'Show Advanced': 'Afficher avancé',
  'Show History Time': 'Afficher l\'heure de l\'historique',
  'Show Inspections': 'Afficher les inspections',
  'Show Questions / Answers': 'Afficher les questions/réponses',
  'Show Services': 'Afficher les services',
  'Sign Up': 'S\'inscrire',
  'Simulate Scan': 'Simuler l\'analyse',
  'Site Deleted': 'Site supprimé',
  'Site Field Information': 'Informations sur le champ du site',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'Les champs du site vous permettront de saisir des informations supplémentaires sur le site, telles que « Emplacement du parking ».',
  'Site Fields': 'Champs du site',
  'Site Information': 'Informations sur le site',
  'Site Report': 'Rapport de chantier',
  'Site Reports': 'Rapports de chantier',
  'Site Service Override': 'Remplacement du service de site',
  'Site Service Overrides': 'Remplacements de services de site',
  'Site Service Settings': 'Paramètres des services du site',
  'Site Settings': 'Paramètres du site',
  'Site Type': 'Type de site',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'Les types de sites vous permettent de modifier les types de services en fonction du site. Par exemple, seuls les clients mensuels afficheraient l\'inspection mensuelle.',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'Les types de sites vous permettent d\'avoir différents types de services sur différents types de sites. Par exemple, vous devrez peut-être effectuer des inspections mensuelles sur un site et seulement une inspection annuelle sur un autre.',
  'Site Types': 'Types de sites',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'Les sites peuvent vous aider à organiser l\'équipement dans des endroits tels que « Bureau » ou « Entrepôt ». Si vous dirigez une société de services, vous pouvez ajouter vos clients en tant que sites. ',
  'Sites': 'Sites',
  'Start Date': 'Date de début',
  'Start Trial': 'Commencer l\'essai',
  'Status': 'Statut',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'Résumé des services sur un site séparés par informations sur le modèle. Exemple 5 Inspections mensuelles avec informations sur le modèle 6LB DRY ABC.',
  'Swap Equipment': 'Échanger de l\'équipement',
  'Swapped equipment': 'Équipement échangé',
  'TEST': 'ESSAYER',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'Le plan EMS est un plan à prix réduit destiné aux services de santé à but non lucratif ou financés par l\'État.  Veuillez choisir un autre forfait si vous ne correspondez pas à ces critères',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'La note contextuelle est utilisée pour vous rappeler des informations importantes concernant l\'emplacement. Il apparaîtra lors de l’ouverture de l’écran de localisation.',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'Il n\'y a pas de sites imprévus avec des inspections, des services ou des défauts en suspens.',
  'There is no equipment at this site with this search criteria and due inspections': 'Il n\'y a aucun équipement sur ce site avec ces critères de recherche et les inspections dues',
  'There is no equipment at this site with this search criteria and due service': 'Il n\'y a aucun équipement sur ce site avec ces critères de recherche et le service dû',
  'This Month': 'Ce mois-ci',
  'Time at Site Detailed': 'Temps passé sur le site détaillé',
  'Time at Site': 'Temps passé sur le site',
  'Time Based Condition': 'Condition basée sur le temps',
  'Today': 'Aujourd\'hui',
  'Transfer Equipment': 'Équipement de transfert',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'Les définitions de services non planifiés peuvent être ajoutées au type d\'équipement dans Paramètres > Types d\'équipement',
  'Unscheduled': 'Non programmé',
  'Updated barcode': 'Code-barres mis à jour',
  'Used Equipment SKU': 'UGS d\'équipement d\'occasion',
  'Used for the billing export for new, swapped and replaced equipment.': 'Utilisé pour l’export de facturation des équipements neufs, échangés et remplacés.',
  'User Deleted': 'Utilisateur supprimé',
  'User Information': 'Informations utilisateur',
  'User': 'Utilisateur',
  'Users': 'Utilisateurs',
  'View on FloorPlan': 'Voir sur FloorPlan',
  'View Terms': 'Voir les conditions',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'Chaque fois que l\'équipement est échangé, l\'exportation de facturation augmentera la quantité sous ce SKU.',
  'Yes, Delete Equipment Field': 'Oui, supprimer le champ d\'équipement',
  'Yes, Delete Equipment Type': 'Oui, supprimer le type d\'équipement',
  'Yes, Delete Equipment': 'Oui, supprimer l\'équipement',
  'Yes, Delete Floor Plan': 'Oui, supprimer le plan d\'étage',
  'Yes, Delete Model Field': 'Oui, supprimer le champ modèle',
  'Yes, Delete Model': 'Oui, supprimer le modèle',
  'Yes, Delete Question': 'Oui, supprimer la question',
  'Yes, Delete Record': 'Oui, supprimer l\'enregistrement',
  'Yes, Delete Service Month': 'Oui, supprimer le mois de service',
  'Yes, Delete Service Type': 'Oui, supprimer le type de service',
  'Yes, Delete Site Field': 'Oui, supprimer le champ du site',
  'Yes, Delete Site Type': 'Oui, supprimer le type de site',
  'Yes, Delete Site': 'Oui, supprimer le site',
  'Yes, Delete User': 'Oui, supprimer l\'utilisateur',
  'Zone': 'Zone',
  'Customer': 'Client',
  'Site': 'Site',
  'All Sites': 'Tous les sites',
  'Loading Customers': 'Chargement des clients',
  'No Customers': 'Aucun client',
  'Add Customer': 'Ajouter un client',
  'Customers are groups of sites with billing information.': 'Les clients sont des groupes de sites contenant des informations de facturation.',
  'Customers': 'Clients',
  'Customer Information': 'Informations client',
  'Delete Customer': 'Supprimer le client',
  'Yes, Delete Customer': 'Oui, supprimer le client',
  'Delete Customer?': 'Supprimer le client ?',
  'Customer Deleted': 'Client supprimé',
  'Create Customer': 'Créer un client',
  'Assign Existing Customer': 'Attribuer un client existant',
  'Edit Customer': 'Modifier le client',
  'Enter a serial number': 'Entrez un numéro de série',
  'Remove Customer': 'Supprimer le client',
  'Find': 'Trouver',
  'Sync Now': 'Synchroniser maintenant',
  'Syncing...': 'Synchronisation...',
  'Find equipment by serial number': 'Rechercher un équipement par numéro de série',
  'Last successful upload was {formattedDate}': 'Le dernier téléchargement réussi remonte au {formattedDate}.',
  'Up to date as of {formattedDate}': 'À jour en date du {formattedDate}',
  'Zones are used to group locations in the location report': 'Les zones sont utilisées pour regrouper les emplacements dans le rapport de localisation',

  'Account Number': 'Numéro de compte',
  'Add Location Override': 'Ajouter un remplacement d\'emplacement',
  'Add New Model': 'Ajouter un nouveau modèle',
  'Add Site Field': 'Ajouter un champ de site',
  'Address Line 2': 'Ligne d\'adresse 2',
  'Agree to': 'Accepter de',
  'All conditions are true': 'Toutes les conditions sont vraies',
  'All Permissions': 'Toutes les autorisations',
  'Allow Text Input': 'Autoriser la saisie de texte',
  'An email with the reset password link below has been sent to': 'Un e-mail contenant le lien de réinitialisation du mot de passe ci-dessous a été envoyé à',
  'An error ocurred while trying to show this page.': 'Une erreur s\'est produite lors de la tentative d\'affichage de cette page.',
  'Any condition is true': 'Toute condition est vraie',
  'Background Color': 'Couleur d\'arrière-plan',
  'Billing and customer controls': 'Facturation et contrôles clients',
  'Building Reports - Safety Scan': 'Rapports de construction - Analyse de sécurité',
  'Change Another Service': 'Changer un autre service',
  'Choose Site': 'Choisir un site',
  'click here': 'Cliquez ici',
  'Closed Date': 'Date de fermeture',
  'Closed Deficiencies': 'Lacunes fermées',
  'Company Information': 'Informations sur l\'entreprise',
  'Company Name': 'Nom de l\'entreprise',
  'Completing Sign Up': 'Terminer l\'inscription',
  'Context ID': 'ID de contexte',
  'Could not find equipment with that barcode': 'Impossible de trouver un équipement avec ce code-barres',
  'Creating invite link...': 'Création d\'un lien d\'invitation...',
  'Current equipment failed to load': 'L\'équipement actuel n\'a pas pu être chargé',
  'Data File': 'Fichier de données',
  'Data Origin': 'Origine des données',
  'Date affected by': 'Date affectée par',
  'Date Completed': 'Date de fin',
  'Date Started': 'Date de début',
  'Delete equipment?': 'Supprimer un équipement ?',
  'Dev Environment': 'Environnement de développement',
  'Disabled For': 'Désactivé pour',
  'Disabled For Location': 'Désactivé pour l\'emplacement',
  'Do not change': 'Ne change pas',
  'Due When': 'Date d\'échéance',
  'Edit Deficiencies': 'Modifier les lacunes',
  'Edit History': 'Modifier l\'historique',
  'Edit Location': 'Modifier l\'emplacement',
  'Edit Schedule': 'Modifier le calendrier',
  'Edit Service': 'Modifier le service',
  'Edit Settings': 'Modifier les paramètres',
  'End Time': 'Heure de fin',
  'Equal to': 'Égal à',
  'Equipment Field': 'Domaine d\'équipement',
  'Equipment replaced': 'Équipement remplacé',
  'Equipment swapped': 'Équipement échangé',
  'Example: Broken Handle': 'Exemple : poignée cassée',
  'Frequency Type': 'Type de fréquence',
  'Generate Reports': 'Générer des rapports',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'Commencez par consulter nos tutoriels sur YouTube ou en configurant votre compte dans les paramètres.',
  'Global Search': 'Recherche globale',
  'Greater than': 'Plus grand que',
  'hasn&apos;t accepted their invite yet. You can': 'n\'a pas encore accepté leur invitation. ',
  'Include In Reports': 'Inclure dans les rapports',
  'landscape LetterHead': 'Paysage',
  'Last Date': 'Dernière date',
  'Last Date Minimum Granularity': 'Granularité minimale de la dernière date',
  'Last Download': 'Dernier téléchargement',
  'Last Upload': 'Dernier téléchargement',
  'Less than': 'Moins que',
  'Locations can only be added on a desktop browser': 'Les emplacements ne peuvent être ajoutés que sur un navigateur de bureau',
  'Looks like you never finished signing up': 'On dirait que tu n\'as jamais fini de t\'inscrire',
  'Metered Condition': 'État mesuré',
  'Mobile Access': 'Accès mobile',
  'Model Number': 'Numéro de modèle',
  'Next Date (Overide)': 'Date suivante (remplacer)',
  'No Conditions': 'Aucune condition',
  'No Options': 'Aucune option',
  'Not equal to': 'Pas égal à',
  'Opened Date': 'Date d\'ouverture',
  'Option Selected': 'Option sélectionnée',
  'Perform On Scan': 'Effectuer lors de l\'analyse',
  'Please click the button below to start your free 3 month trial': 'Veuillez cliquer sur le bouton ci-dessous pour démarrer votre essai gratuit de 3 mois',
  'Please review the terms below': 'Veuillez consulter les conditions ci-dessous',
  'Portrait LetterHead': 'En-tête de lettre portrait',
  'Postal Code': 'Code Postal',
  'Powered By': 'Alimenté par',
  'Preventive Maintenance': 'Entretien préventif',
  'Profile Image': 'Image de profil',
  'Receive marketing emails': 'Recevoir des e-mails marketing',
  'Rivison Inc.': 'Rivison Inc.',
  'Search Sites...': 'Rechercher des sites...',
  'Serial Number': 'Numéro de série',
  'Service is Unscheduled': 'Le service n\'est pas programmé',
  'Service Options': 'Options de services',
  'Service or Inspection Due': 'Service ou inspection dû',
  'Show All': 'Afficher tout',
  'Show site selector in top corner': 'Afficher le sélecteur de site dans le coin supérieur',
  'Sign-Up Failed. Ensure the email is not already is use.': 'Échec de l\'inscription. ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'Désolé, une erreur s\'est produite lors de la tentative de création d\'un lien d\'invitation. ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'Désolé, il semble que vous soyez hors ligne. ',
  'Start Time': 'Heure de début',
  'Successfully updated profile': 'Profil mis à jour avec succès',
  'terms and conditions': 'termes et conditions',
  'Text Input': 'Saisie de texte',
  'The date below is used to show history records only.': 'La date ci-dessous est utilisée pour afficher uniquement les enregistrements de l\'historique.',
  'This will just take a moment': 'Cela prendra juste un moment',
  'Time Condition': 'Conditions temporelles',
  'Time Zone': 'Fuseau horaire',
  'to generate another invite link.': 'pour générer un autre lien d\'invitation.',
  'Toggle Flashlight': 'Basculer la lampe de poche',
  'Type more characters to narrow the search further': 'Tapez plus de caractères pour affiner davantage la recherche',
  'Use text answer for': 'Utiliser la réponse textuelle pour',
  'Version:': 'Version:',
  'View Deficiencies': 'Voir les lacunes',
  'View Equipment': 'Voir l\'équipement',
  'View History': 'Afficher l\'historique',
  'View Location': 'Voir l\'emplacement',
  'View Schedule': 'Voir le calendrier',
  'View Service': 'Voir le service',
  'View Settings': 'Afficher les paramètres',
  'We hope to see you again.': 'Nous espérons vous revoir.',
  'Web Login': 'Connexion Web',
  'Welcome,': 'Accueillir,',
  'White Label': 'Marque blanche',
  'Work Day End Time': 'Heure de fin de journée de travail',
  'Work Day Start Time': 'Heure de début de la journée de travail',
  'You must agree to the terms and conditions': 'Vous devez accepter les termes et conditions',
  'Your Subscription Has Been Canceled': 'Votre abonnement a été annulé',
};
